import React from 'react';
import { Input as AntInput, InputNumber } from 'antd';
import { Icon } from "View/Common";
import Wrapper from './Input.style';
import { Subject } from "rxjs";

interface IProps {
    rows?: number,
    password?: boolean,
    wrapperClassName?: string,
    className?: string,
    prefixIcon?: string,
    type?: string,
    subject?: Subject<any>,
    placeholder?: string,
    textArea?: boolean,
    name?: string,
    defaultValue?: any,
    value?: any,
    onChange?: (value: any) => any,
    min?: number,
    max?: number,
    step?: number,
    parser?: any,
    focus?: boolean,
}

type TProps = IProps

const utilizeFocus = () => {
    const ref: React.RefObject<any> = React.createRef()
    const setFocus = () => {ref.current &&  ref.current.focus()}

    return { setFocus, ref }
}

export class Input extends React.Component<TProps> {

    inputFocus: any;

    constructor(props: TProps) {
        super(props);

        this.inputFocus = utilizeFocus()
    }

    componentDidMount() {
        if(this.props.focus) {
            this.inputFocus.setFocus();
        }
    }

    handleOnChange = (evt: any) => {
        if(this.props.subject) {
            this.props.subject.next( evt.target.value );
        }
    };

    render() {
        let prefix = null;
        const { wrapperClassName, prefixIcon, type, textArea, focus, ...props } = this.props;

        if( prefixIcon ) {
            prefix = <Icon type={ prefixIcon } />
        }
        const inputProp = {
            prefix,
            onChange: this.handleOnChange,
            ...props,
        };

        let input = <AntInput { ...inputProp } ref={ this.inputFocus.ref } />;

        switch(true) {
            case (!!textArea || `${type}`.toLowerCase() === 'text') :
                // @ts-ignore
                input = <AntInput.TextArea { ...inputProp } />;
                break;

            case (!!this.props.password) :
                input = <AntInput.Password { ...inputProp } />;
                break;
            case (!!type && `${type}`.toLowerCase() === 'number') :
                // @ts-ignore
                input = <InputNumber { ...inputProp } />;
                break;

            // no default
        }

        return(
            <Wrapper className={ wrapperClassName }>
                { input }
            </Wrapper>
        );
    }

}
